// extracted by css-extract-rspack-plugin
export default {"Text":"repository-renderer-module__Text__fVxhb"};